import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { InvoiceNoticeLogInitialState } from '../globalSlices/invoiceNoticeLogSlice';
import { getSupplierInvoiceNoticeLogs } from '../services/invoiceNoticeLogService';
import { InvoiceNoticeLog } from '../../utils/interfaces/invoiceNoticeLogInterfaces';

export const getSupplierInvoiceNoticeLogsExtraReducer = (
  builder: ActionReducerMapBuilder<InvoiceNoticeLogInitialState>
) => {
  const reducerId = 'getSupplierInvoiceNoticeLogs';
  builder.addCase(getSupplierInvoiceNoticeLogs.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierInvoiceNoticeLogs.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.invoiceNoticeLogs = action.payload.data as InvoiceNoticeLog[];
      }
    }
  );
  builder.addCase(getSupplierInvoiceNoticeLogs.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
